module.exports = __webpack_public_path__ + "img/22.afca59b8.png";